import"./backdrop-dialog.5d8ed14aed4b.js";

export class CareQuality {
  constructor() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".tqc-care-quality")) {
        document.getElementById("care-quality-modal")?.showModal();
      }
    });
  }
}
